import React from 'react';
import SEO from "../common/SEO";
import Layout from '../common/Layout';
import AboutTestamonial from '../Testamonial/AboutTestamonial'
import Separator from "../separator/Separator";
import Typed from 'react-typed';
import ChaptersBrand from '../elements/brand/ChaptersBrand';
import SectionTitle from '../elements/sectionTitle/SectionTitle';
import AboutGoals from '../elements/about/AboutGoals';
import ChaptersProgressBar from '../elements/progressbar/ChaptersProgressBar';
const backgroundimages =[
    {
        img:'Slide-Area-Bg.jpg'
    },
    {
        img:'Slide-Area-Bg-1.jpg'
    },
]

const Home = () => {
    return (
        <>
            <SEO title="Home Page IEEE ISSAT Sousse || Home Page IEEE ISSATSo" />
            <main className="page-wrapper">
                <Layout>
                
                
                {/** Starting the slide Area */}
                <Separator />
                <div className="slider-area slider-style-2 height-952 bg_image" data-black-overlay="2" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/Slide-Area-Bg.jpg)`}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <h1 className="title HomeTitle display-two"> Come as a Student, <br />{" "}
                                        <Typed
                                            strings={[
                                                "Leave as a Leader.",
                                            ]}
                                            typeSpeed={70}
                                            backSpeed={5}
                                            backDelay={400}
                                            loop
                                        />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/** Ending the slide Area */}
                
                
                {/*Starting Our Chapters Area */}
                <Separator />
                <div className="rwt-brand-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Our Chapters"
                                        title = "IEEE ISSATSo Chapters"
                                        description = ""
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 mt--50">
                                    <ChaptersBrand brandStyle="brand-style-2" />
                                </div>
                            </div>
                        </div>
                    </div>
                {/*Ending Our Chapters Area */}


                {/*Starting Our Goals Area */}
                <Separator />
                <AboutGoals />
                {/*Starting progress */}
                <div className="rwt-counterup-area rn-section-gapBottom mt_dec--30">
                    <div className="container">
                        <ChaptersProgressBar column="col-lg-3 col-md-6 col-sm-6 col-12" counterStyle="counter-style-4" textALign="text-center" />   
                    </div>
                </div>
                {/*Ending progress */}
                {/*Ending Our Goals Area */}
                
                {/** Starting the About Area */}
                <div className="blog-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <AboutTestamonial />
                            </div>
                            </div>
                        </div>
                    </div>
                {/** Ending the About Area */}

                
                <Separator />
                </Layout>
            </main>
        </>
    )
}

export default Home;
